import React from "react";

import { Container, Name, Especie, TextResult } from "./styles";

//Icons
import cpfIcon from "@assets/cpfIcon.svg";
import { GoDotFill } from "react-icons/go";
import { BiMap } from "react-icons/bi";
import { AiOutlineCalendar } from "react-icons/ai";
import { AiOutlineEye } from "react-icons/ai";

//MUI
import { Avatar } from "@mui/material";

//utils
import { avatarHelper } from "@helpers/avatar";
import { datetimeHelper } from "@helpers/datetime";
import { speciesHelper } from "@helpers/species";
import { Client } from "@domain/models/Client";

const options = [
  "Contrato fechado",
  "Contrato fechado por indicação",
  "Endereço não encontrado",
  "Litispendência",
  "Já tem advogado",
  "Retornar",
  "Não tem direito",
  "Não tem interesse",
  "Localidade diversa",
  "",
];

const optionsColors = [
  "var(--success)",
  "var(--success)",
  "var(--red)",
  "var(--red)",
  "var(--red)",
  "var(--yellow)",
  "var(--red)",
  "var(--red)",
  "var(--red)",
  "var(--grey2)",
];

type Props = {
  data: Client;
  onView: () => void;
};

function DatabaseItem({ data, onView }: Props) {
  return (
    <Container>
      <Name>{data.name}</Name>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.cpf}</h4>
      </div>
      <div>
        <Avatar
          alt="Avatar"
          src={avatarHelper.getUserAvatar(data.operatorId)}
          sx={{
            width: 20,
            height: 20,
            borderRadius: 100,
            borderColor: "white",
            borderWidth: 10,
          }}
        />
        <h4>{data.operatorName ? data.operatorName : "Sem operador"}</h4>
      </div>
      <Especie
        color={speciesHelper.getSpecieTag(data.specie).tagColor}
        textColor={speciesHelper.getSpecieTag(data.specie).textColor}
      >
        {data.specie}
      </Especie>
      <div>
        <GoDotFill
          size={10}
          color={optionsColors[options.findIndex((x) => x == data.lastReportResult)]}
        />
        <TextResult color={optionsColors[options.findIndex((x) => x == data.lastReportResult)]}>
          {data.lastReportResult ? data.lastReportResult : "Não atendido"}
        </TextResult>
      </div>

      <div>
        <BiMap size={15} color="var(--grey2)" />
        <h4>{data.cityMap ? data.cityMap : data.addresses["S1"].city}</h4>
      </div>

      <div>
        <AiOutlineCalendar color="var(--grey2)" />
        <h4>
          {datetimeHelper.getDate(data.lastReportDate ? data.lastReportDate : data.createdAt)}
        </h4>
      </div>
      <div>
        <AiOutlineEye onClick={onView} cursor="pointer" size={18} color="#808B9F" fill="#808B9F" />
      </div>
    </Container>
  );
}

export default DatabaseItem;
